import * as React from "react";

export const CompanyUserIcon = ({fill=""}) => (
  <svg
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
	  viewBox="0 0 717.06 512"
  >
    <g>
      <path d="M160,256c0,22.2,1.1,43.6,3.3,64h185.4c2.1-20.4,3.3-41.8,3.3-64s-1.1-43.6-3.3-64H163.3C161.2,212.4,160,233.8,160,256z" />
      <path d="M493.3,160C463.4,85.9,399.7,29.1,321.4,8.4c25.5,34.2,45.3,87.7,55.3,151.6H493.3z" />
      <path d="M190.6,8.4c-78.4,20.7-142,77.5-172,151.6h116.7C145.3,96.1,165.1,42.6,190.6,8.4z" />
      <path
        d="M470.31,320c-6.86-14.51-10.48-30.47-10.48-47c0-29.39,11.44-57.02,32.21-77.79c1.1-1.1,2.22-2.17,3.36-3.21H380.8
		c2.1,20.6,3.2,42,3.2,64s-1.1,43.4-3.2,64H470.31z"
      />
      <path
        d="M344.3,160c-6-36.5-15.4-68.7-27-94.7c-10.5-23.6-22.2-40.7-33.5-51.5C272.6,3.2,263.3,0,256,0s-16.6,3.2-27.8,13.8
		c-11.3,10.8-23,27.9-33.5,51.5c-11.5,26.1-20.9,58.3-27,94.7H344.3z"
      />
      <path
        d="M167.7,352c6.1,36.4,15.4,68.6,27,94.6v0.1c10.5,23.6,22.2,40.7,33.5,51.5c11.2,10.6,20.5,13.8,27.8,13.8
		s16.6-3.2,27.8-13.9c11.3-10.8,23-27.9,33.5-51.5c11.5-26,20.9-58.2,27-94.6H167.7z"
      />
      <path
        d="M490.76,358.27c0.9-2.05,1.77-4.12,2.62-6.2c-0.02-0.02-0.05-0.04-0.07-0.07H376.8c-10.1,63.9-29.8,117.4-55.3,151.6
		c26.84-7.1,51.95-18.44,74.58-33.26C399.5,415.61,438.85,370.47,490.76,358.27z"
      />
      <path d="M18.6,352c30,74.1,93.6,130.9,172,151.6c-25.5-34.2-45.3-87.7-55.3-151.6H18.6z" />
      <path d="M128,256c0-22,1.1-43.4,3.2-64H8.1C2.8,212.5,0,233.9,0,256c0,22.1,2.8,43.5,8.1,64h123.1C129.1,299.4,128,278,128,256z" />
    </g>
    <g>
      <circle cx="573.06" cy="272" r="80" />
      <path
        d="M429.06,477.1c0,19.3,15.6,34.9,34.9,34.9h218.2c19.3,0,34.9-15.6,34.9-34.9c0-51.4-41.7-93.1-93.1-93.1h-101.8
		C470.76,384,429.06,425.7,429.06,477.1z"
      />
    </g>
  </svg>
);
